import React, { Fragment, useState, useEffect } from 'react';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import Captcha from './Captcha';
import { IS_DEV, STORAGE_FEATURES_TOGGLE } from '../constants/App';
import { FeaturesToggleDto } from '../dto/FeaturesToggleDto';
import { useStateWithLocalStorage } from '../hooks/state/useStateWithLocalStorage';

interface IButtonCaptchaProps {
  textButton: string;
  onClick: () => void;
  startIcon?: React.ReactNode;
  fullWidth?: boolean;
  centerContent?: boolean;
}

const ButtonCaptcha = ({
  textButton,
  onClick,
  startIcon,
  fullWidth,
  centerContent,
}: IButtonCaptchaProps) => {
  const [featuresToggle] = useStateWithLocalStorage<FeaturesToggleDto>(STORAGE_FEATURES_TOGGLE);
  const [isCaptchaOk, setIsCaptchaOk] = useState<boolean>(IS_DEV);

  useEffect(() => {
    if (featuresToggle) setIsCaptchaOk(!featuresToggle.captchaElecOffice);
  }, [featuresToggle]);

  const handleOnChangeCaptcha = (isValide: boolean) => setIsCaptchaOk(isValide);

  return (
    <Fragment>
      <div
        className={clsx('w-full ', centerContent ? 'flex justify-center' : '')}
      >
        {!isCaptchaOk && <Captcha onChange={handleOnChangeCaptcha} />}
        {isCaptchaOk && (
          <Button
            type='button'
            fullWidth={fullWidth}
            variant='contained'
            color='primary'
            startIcon={startIcon}
            onClick={() => onClick()}
          >
            {textButton}
          </Button>
        )}
      </div>
    </Fragment>
  );
};
export default ButtonCaptcha;
